export const BRAND_POPULAR_MODELS: Record<number, string[]> = {
  // 20471120: 2
  2: ["hyoma", "paper recycling", "patchwork", "rabbit"],

  // 11 by Boris Bidjan Saberi: 366
  366: ["bamba", "salomon", "boro", "coating"],

  // A.P.C.: 14
  14: ["petit standard", "half moon bag", "butler", "rescue"],

  // Acne Studios: 242
  242: [
    "musubi",
    "jensen",
    "velocite",
    "face logo",
    "1996",
    "river",
    "manhattan",
    "mohair",
    "pop",
    "pira",
  ],

  // Alice Auaa: 10
  10: ["spiderweb", "net", "corset", "gauze"],

  // Alexander McQueen: 8
  8: [
    "oversized sneaker",
    "tread slick",
    "knuckle clutch",
    "armadillo",
    "heroine",
    "skull",
    "scarf",
  ],

  // Ann Demeulemeester: 12
  12: ["backlace boots", "scamosciato", "vitello", "feather", "combat boots"],

  // Arc'teryx: 434
  434: ["alpha sv", "beta ar", "veilance", "system a", "leaf"],

  // Auralee: 250
  250: ["hard twist", "finx", "stand up"],

  // A-Cold-Wall*: 254
  254: ["geo", "shard", "converse", "utility"],

  // Balenciaga: 20
  20: [
    "triple s",
    "track",
    "defender",
    "city bag",
    "le cagole",
    "steroid boot",
    "speed trainer",
    "3xl",
  ],

  // Balmain: 21
  21: ["biker jeans", "double breasted", "unicorn", "pierre balmain"],

  // Beauty:Beast: 23
  23: ["dark knight", "digital camo", "bunny bag", "scroll"],

  // Beams: 247
  247: ["ssz", "plus", "boy"],

  // Blackmeans: 27
  27: ["coin pouch", "knuckle lighter", "sid vicious", "biker jacket"],

  // Bode: 271
  271: ["quilt", "lace", "senior cord", "hand painted"],

  // Boris Bidjan Saberi: 29
  29: ["bamba", "p13", "salomon", "boro", "11"],

  // Bottega Veneta: 30
  30: ["cassette", "jodie", "puddle boot", "tire boot", "intrecciato", "cabat"],

  // Backlash: 19
  19: ["italian shoulder", "double riders", "german calf", "isamu katayama"],

  // Carpe Diem: 31
  31: ["s21", "s23", "back zip", "altieri"],

  // Carol Christian Poell: 33
  33: ["drip sneaker", "tornado boot", "object dyed", "gloves", "fencing jacket", "prosthetic"],

  // Cav Empt: 322
  322: ["icon pullover", "ziggurat", "overdye", "utility"],

  // Celine: 35
  35: ["triomphe", "luggage phantom", "box bag", "dylan trouser", "kurt jeans"],

  // Chopova Lowena: 37
  37: ["carabiner skirt", "fleece", "recycled"],

  // Christian Louboutin: 469
  469: ["red bottom", "spikes"],

  // Chrome Hearts: 39
  39: [
    "cross patch",
    "floral cross",
    "dagger",
    "cemetery ring",
    "tiny e",
    "roller belt",
    "sex records",
  ],

  // C.P. Company: 258
  258: ["goggle jacket", "mille miglia", "metropolis", "urban protection"],

  // Comme des Garçons: 41
  41: ["play heart", "staff coat", "magic of love", "market", "pvc tote"],

  // Craig Morrison: 183
  183: ["spike bag", "bug bag", "heart bag"],

  // Devoa: 46
  46: ["anatomy", "washi", "guidi leather", "jodhpur"],

  // Dior Homme: 47
  47: ["navigate boots", "strip denim", "claw mark", "luster", "b23", "jake jeans", "napoleon"],

  // Dries Van Noten: 49
  49: ["back zip bomber", "marilyn monroe", "embroidery", "tie dye", "verner paton"],

  // Eckhaus Latta: 272
  272: ["lapped baby", "wide leg", "el"],

  // Engineered Garments: 52
  52: ["bedford jacket", "fatigue pant", "highland parka", "workaday"],

  // Enfants Riches Déprimés: 240
  240: ["high school", "therapy", "lou", "divorce", "punk"],

  // Fendi: 406
  406: ["baguette", "peekaboo", "zucca", "first", "spy"],

  // FFFFPostalservice: 344
  344: ["cargo", "tactical", "hybrid"],

  // Final Home: 53
  53: ["survival parka", "home1", "multi pocket", "goblin"],

  // Fumito Ganryu: 422
  422: ["sarouel", "coach jacket", "trapeze"],

  // FrizmWORKS: 473
  473: ["karakoram", "mountain parka", "deck jacket"],

  // Givenchy: 63
  63: ["antigona", "shark boot", "rottweiler", "bambi", "pandora"],

  // Gianni Versace: 195
  195: ["medusa", "barocco", "bondage"],

  // Giorgio Armani: 248
  248: ["power suit"],

  // Greg Lauren: 65
  65: ["tent fabric", "kimono", "50/50", "army", "sherpa"],

  // Guidi: 67
  67: ["pl1", "pl2", "992", "788", "988", "back zip", "front zip"],

  // Gucci: 66
  66: ["jackie bag", "marmont", "ace sneaker", "horsebit", "princetown", "dionysus"],

  // Hedi Slimane: 69
  69: ["teddy jacket", "wyatt", "skinny"],

  // Hed Mayner: 444
  444: ["oversized trench", "vibram", "pleated"],

  // Helmut Lang: 70
  70: ["painter jeans", "astro biker", "bondage", "bulletproof vest", "mummy", "ballistic"],

  // Hermes: 275
  275: ["birkin", "kelly", "constance", "oran", "chaine d'ancre"],

  // h.NAOTO: 73
  73: ["steam", "blood", "frill", "seven", "birdcage"],

  // Hysteric Glamour: 78
  78: ["snake denim", "kinky", "detroit", "mesh cap", "nudies"],

  // If Six Was Nine: 79
  79: ["mudmax", "butter knife", "reptile", "spider", "gilet"],

  // Iron Heart: 446
  446: ["21oz", "25oz", "ultra heavy"],

  // Isabel Benenato: 396
  396: ["knitwear", "linen", "asymmetric"],

  // Isabel Marant: 408
  408: ["wedge sneaker", "etoile", "beckett", "bobby"],

  // Innerraum: 445
  445: ["object", "shell", "crossbody", "vest"],

  // Issey Miyake: 81
  81: ["pleats please", "bao bao", "homme plisse", "parachute"],

  // Jil Sander: 86
  86: ["tangle bag", "cannolo", "bamboo", "wander", "vibram"],

  // JW Anderson: 261
  261: ["pierce bag", "run star hike", "bumper", "cap bag", "pigeon"],

  // John Alexander Skelton: 87
  87: ["collection", "handwoven", "pollack"],

  // Junya Watanabe: 90
  90: ["poem", "patchwork", "levis", "north face", "solaris"],

  // Julius _7: 89
  89: ["gas mask", "prism", "twisted", "dimension"],

  // Kapital: 95
  95: [
    "bone denim",
    "century denim",
    "ring coat",
    "skeleton",
    "smiley",
    "damask fleece",
    "kountry",
  ],

  // Kiko Kostadinov: 97
  97: ["gel burz", "trivia", "bindra", "harkman", "camper"],

  // KMRii: 180
  180: ["ammonite", "bone", "studs", "leather bag", "boots"],

  // Kolor: 312
  312: ["beacon"],

  // Kris Van Assche: 431
  431: ["multi lace", "sneaker", "tailoring"],

  // Label Under Construction: 104
  104: ["reversible", "laser cut", "j pant", "punch hole"],

  // Lad Musician: 105
  105: ["music note", "cobain", "fender", "flower"],

  // Le Grand Bleu (L.G.B.): 106
  106: ["bono", "shirk", "luna", "boxer", "s-wolf"],

  // Lemaire: 108
  108: ["croissant bag", "kaolin", "chinese loafers", "dry silk", "twisted"],

  // Loewe: 276
  276: ["puzzle bag", "elephant", "hammock", "flamenco", "anagram"],

  // Louis Vuitton: 410
  410: ["keepall", "speedy", "neverfull", "alma", "capucines", "archlight", "millionaire"],

  // m.a+: 112
  112: ["aviator", "accordion", "cross", "spiral", "maurizio amadei"],

  // Maison Kitsune: 347
  347: ["fox head", "parisien", "chillax"],

  // Maison Martin Margiela: 113
  113: [
    "tabi",
    "replica gat",
    "5 zip",
    "glam slam",
    "fusion sneaker",
    "future high",
    "artisanal",
    "4 stitch",
  ],

  // Manolo Blahnik: 399
  399: ["hangisi", "lurum"],

  // Marni: 121
  121: ["fussbett", "trunk bag", "mohair", "tropical wool", "big foot"],

  // Martine Rose: 123
  123: ["napa", "twist", "square toe", "bulldog", "football"],

  // Marsell: 451
  451: ["zuccolona", "gomme", "derby", "back zip"],

  // Mihara Yasuhiro: 127
  127: ["peterson", "wayne", "hank", "blake", "baker"],

  // Miu Miu: 226
  226: ["wander bag", "ballet flats", "matelasse", "mini skirt", "glitter"],

  // Momotaro: 453
  453: ["going to battle", "copper label", "vintage label"],

  // Moncler: 301
  301: ["maya", "bady", "badete", "grenoble", "puffer", "down jacket"],

  // Namacheko: 454
  454: ["krokus", "diamond", "paanju"],

  // Nanamica: 285
  285: ["goretex", "coolmax", "alphadry"],

  // Neighborhood: 455
  455: ["incense chamber", "savage", "thunderbolt", "booze"],

  // Needles: 314
  314: ["track pants", "mohair", "rebuild", "hd pants", "girls don't cry"],

  // Nonnative: 319
  319: ["dweller", "trooper", "goretex"],

  // Norse Projects: 472
  472: ["goretex", "niels", "aros"],

  // Number (N)ine: 130
  130: [
    "hybrid cargo",
    "pain denim",
    "gotham hoodie",
    "crying heart",
    "school of visual comedy",
    "mickey",
  ],

  // Our Legacy: 132
  132: ["camion boot", "third cut", "coco", "ladon", "borrowed bd", "vast cut"],

  // orSlow: 288
  288: ["105", "107", "fatigue"],

  // Paul Harnden: 133
  133: ["shoemakers", "summit", "mac coat", "jerkin"],

  // Peter Do: 134
  134: ["metal tip", "spacer", "tattoo", "clear heel"],

  // Porter Yoshida: 326
  326: ["tanker", "force", "heat", "helmet bag"],

  // Post Archive Faction: 221
  221: ["4.0", "3.1", "right", "center", "left"],

  // Prada: 225
  225: ["americas cup", "cloudbust", "monolith", "re-edition", "galleria", "nylon", "symbole"],

  // Proenza Schouler: 458
  458: ["ps1", "lunch bag", "hava", "tie dye"],

  // Raf Simons: 137
  137: [
    "ozweego",
    "riot bomber",
    "virginia creeper",
    "consumed",
    "sterling ruby",
    "response trail",
    "poltergeist",
    "antwerp",
    "nebraska",
  ],

  // Rene Caovilla: 412
  412: ["snake"],

  // Rick Owens: 138
  138: [
    "geobasket",
    "ramones",
    "dunks",
    "kiss heels",
    "bauhaus cargo",
    "tyrone jeans",
    "tractor boots",
    "megalace",
    "creatch",
  ],

  // Rick Owens DRKSHDW: 355
  355: ["ramones", "detroit cut", "creatch cargo", "pusher", "aircut"],

  // Roen: 197
  197: ["skull", "mickey", "leopard", "swarovski"],

  // Sacai: 427
  427: ["waffle", "bomber", "nike", "sponge sweat", "ldwaffle"],

  // Saint Laurent: 140
  140: ["wyatt boot", "teddy jacket", "l01", "sac de jour", "kate", "cassandre"],

  // Samurai Jeans: 460
  460: ["heavyweight", "17oz", "zero"],

  // Shinya Kozuka: 279
  279: ["baggy", "workwear", "painted"],

  // Share Spirit: 144
  144: ["victorian", "lace", "antique", "military"],

  // Snow Peak: 286
  286: ["takibi", "flexible insulated", "titanium"],

  // South2 West8: 289
  289: ["tenkara", "carmel", "mesh"],

  // Stone Island: 337
  337: ["ice jacket", "shadow project", "nylon metal", "tela stella", "ghost piece", "badge"],

  // Sugar Cane: 463
  463: ["hawaii", "okinawa", "1947"],

  // Sulvam: 147
  147: ["cut off", "gabardine", "layered"],

  // Supreme: 281
  281: ["box logo", "north face", "dunk", "photo tee", "bogo"],

  // Telfar: 150
  150: ["shopping bag", "bushwick birkin", "logo", "circle"],

  // The North Face Purple Label: 308
  308: ["65/35", "berkeley", "mountain parka"],

  // The Old Curiosity Shop: 182
  182: ["hog toe", "bigfoot", "daita kimura"],

  // The Row: 245
  245: ["margaux bag", "ascot", "ginza", "bare sandal"],

  // The Soloist: 146
  146: ["kurt", "western", "balloon", "oversized"],

  // Thom Browne: 153
  153: ["4 bar", "shrunken suit", "hector bag", "grosgrain", "tricolor"],

  // Undercover: 157
  157: [
    "85 denim",
    "scab",
    "gilapple",
    "witch's cell division",
    "arts and crafts",
    "joy division",
    "grace",
    "but beautiful",
  ],

  // Valentino: 249
  249: ["rockstud", "vlogo", "pink pp", "roman stud"],

  // Vetements: 161
  161: [
    "titanic",
    "snoop dogg",
    "total fucking darkness",
    "police cargo",
    "dhl",
    "unicorn",
    "spike",
  ],

  // Vivienne Westwood: 164
  164: ["pearl choker", "orb", "corset", "pirate boots", "rocking horse", "armor ring"],

  // Visvim: 163
  163: ["fbt", "christo", "grizzly boots", "social sculpture", "kerchief down", "skagway", "ict"],

  // Walter Van Beirendonck: 165
  165: ["w&lt", "wild and lethal", "skeleton", "puk puk", "kiss the future"],

  // Wacko Maria: 466
  466: ["guilty parties", "leopard", "maria", "aloha"],

  // Y-3: 361
  361: ["qasa", "kaiwa", "kusari", "yohji star"],

  // Y/Project: 170
  170: ["multi cuff", "cowboy cuff", "wire", "double layer", "accordion"],

  // Yeezy: 171
  171: ["boost", "foam runner", "slide", "700", "350"],

  // Yohji Yamamoto: 173
  173: ["pour homme", "balloon pants", "skull rose", "doctor jacket", "crow"],

  // Yasuyuki Ishii: 172
  172: ["leather", "asymmetric", "industrial"],

  // Commes des Garcons Black: 351
  351: ["nike", "drop crotch", "polka dot"],
};

/**
 * Get popular models for a specific brand by brand ID
 * @param brandId - The brand ID to look up
 * @returns Array of popular model keywords for the brand, or undefined if not configured
 */
export const getPopularModelsForBrand = (brandId: number): string[] | undefined => {
  return BRAND_POPULAR_MODELS[brandId];
};

/**
 * Check if a brand has custom popular models configured
 * @param brandId - The brand ID to check
 * @returns True if the brand has custom popular models configured
 */
export const hasBrandPopularModels = (brandId: number): boolean => {
  return brandId in BRAND_POPULAR_MODELS;
};

/**
 * Get all brand IDs with popular models configured
 * @returns Array of brand IDs that have custom popular models
 */
export const getBrandIdsWithPopularModels = (): number[] => {
  return Object.keys(BRAND_POPULAR_MODELS).map(Number);
};

/**
 * Get default popular models (for brands without custom configuration)
 * @returns Array of default popular model keywords
 */
export const getDefaultPopularModels = (): string[] => {
  return [
    "hoodie",
    "t-shirt",
    "sneakers",
    "jacket",
    "pants",
    "bag",
    "shirt",
    "boots",
    "hat",
    "denim",
  ];
};
